import api from './api';

export const getSupplyRequests = (params) => api.get('/wrike/supply-requests', { params });

export const createSupplyRequest = (data) => api.post('/wrike/supply-requests', data);

export const lookupWrikeFolder = (params) => api.get('/wrike/folders/lookup', { params });